import React from 'react';
import './HouseDesign.css';
import useScrollToTop from './useScrollToTop';
import image2 from '../img/houseplan.jpg';
import ReusableLanding from './ReusableLanding';
import { Link } from 'react-router-dom';
import FAQ from './FAQ';
import DesignProcess from './DesignProcess';
import HouseplanfaqData from './Houseplanfaqdata';
import floorplan1 from '../img/floor_plan1.jpg';
import floorplan2 from '../img/img_floorplan_6.jpg'; 
import floorplan3 from '../img/img_floorplan_4.jpeg';
import floorplan4 from '../img/img_floorplan_2.jpeg'; // Replace with actual images
import floorplan5 from '../img/img_floorplan_3.jpeg'; // Replace with actual images
import floorplan6 from '../img/floor_plan_5.jpg'; // Replace with actual images
import floorplan7 from '../img/floor_plan_6.jpg'; 
import floorplan8 from '../img/floor_plan_7.jpg'; 
import FloorPlanAnimation from './FloorPlanVideo';
import { FaRulerCombined, FaVectorSquare, FaHome, FaPencilRuler,FaFileAlt,FaLightbulb } from 'react-icons/fa'; // Import relevant icons

const FloorPlan = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Floor Plan"
                description="A well-designed floor plan is the foundation of a functional and comfortable home. Explore our range of floor plan services to optimize your living space."
            />
            <div className="house-design-page">
                <section className="floor-plan-services-section">
                    <h2>Our Comprehensive Floor Plan Services</h2>
                    <p>We offer a range of detailed and innovative floor plan services to meet diverse needs, from initial concepts to detailed construction documents.</p>
                    <div className="floor-plan-services-grid">
                        <div className="floor-plan-service-item">
                            <FaRulerCombined className="service-icon" />
                            <h3>Detailed 2D Floor Plans</h3>
                            <p>Our precise 2D floor plans provide accurate room dimensions, wall layouts, door and window placements, and furniture arrangements. These plans are essential for understanding spatial relationships and functionality.</p>
                            <ul>
                                <li>Precise measurements and scaling</li>
                                <li>Clear labeling of rooms and features</li>
                                <li>Furniture layout options</li>
                                <li>Suitable for initial planning and permits</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaVectorSquare className="service-icon" />
                            <h3>Immersive 3D Floor Plans</h3>
                            <p>Visualize your future home with our stunning 3D floor plans. These plans offer a realistic perspective of the interior space, helping you understand volume, flow, and potential design aesthetics.</p>
                            <ul>
                                <li>Realistic textures and finishes</li>
                                <li>Multiple viewing angles</li>
                                <li>Enhanced understanding of spatial volume</li>
                                <li>Ideal for presentations and visualization</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaHome className="service-icon" />
                            <h3>Renovation and Remodeling Floor Plans</h3>
                            <p>Planning a renovation? Our specialized floor plans for existing spaces help you visualize and optimize your remodeling project, ensuring seamless integration of new designs with the current structure.</p>
                            <ul>
                                <li>Accurate representation of existing structures</li>
                                <li>Integration of new layouts and features</li>
                                <li>Identification of structural considerations</li>
                                <li>Facilitates communication with contractors</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaPencilRuler className="service-icon" />
                            <h3>Custom Floor Plan Design</h3>
                            <p>Tailored to your unique lifestyle and requirements, our custom floor plan design service involves in-depth consultation and iterative design to create a home that perfectly fits your needs and preferences.</p>
                            <ul>
                                <li>Personalized design consultations</li>
                                <li>Iterative design process with feedback</li>
                                <li>Optimization for your specific needs</li>
                                <li>Creation of unique and functional layouts</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaFileAlt className="service-icon" /> {/* You might need to import this */}
                            <h3>Construction Document Sets</h3>
                            <p>Beyond basic floor plans, we provide comprehensive construction document sets, including detailed plans, elevations, sections, and specifications necessary for obtaining building permits and guiding the construction process.</p>
                            <ul>
                                <li>Detailed architectural drawings</li>
                                <li>Structural and MEP (Mechanical, Electrical, Plumbing) layouts (optional add-on)</li>
                                <li>Material specifications</li>
                                <li>Essential for accurate construction and costing</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaLightbulb className="service-icon" /> {/* You might need to import this */}
                            <h3>Space Planning and Optimization</h3>
                            <p>Maximize the functionality and flow of your home with our expert space planning services. We analyze your needs and create layouts that optimize every square foot for comfortable and efficient living.</p>
                            <ul>
                                <li>Analysis of traffic flow and adjacencies</li>
                                <li>Furniture placement strategies</li>
                                <li>Consideration of natural light and ventilation</li>
                                <li>Enhancing overall livability</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="benefits-section">
    <h2>Unlock the Potential of Your Home with Professional Floor Plans</h2>
    <p className="benefits-intro">Investing in a professionally designed floor plan goes beyond just lines on paper. It's about creating a home that truly works for you, enhancing your daily life and maximizing your investment.</p>
    <ul className="benefits-list">
        <li>
            <div className="benefit-icon"><i className="fas fa-arrows-alt"></i></div>
            <h3>Optimized Space Utilization</h3>
            <p>Say goodbye to wasted corners and awkward layouts. Our expert planning ensures every square foot is thoughtfully utilized, creating more functional and spacious living areas.</p>
        </li>
        <li>
            <div className="benefit-icon"><i className="fas fa-route"></i></div>
            <h3>Seamless Flow and Functionality</h3>
            <p>Experience a home that lives well. We design intuitive layouts that promote a natural flow between rooms, making everyday tasks easier and enhancing the overall livability of your space.</p>
        </li>
        <li>
            <div className="benefit-icon"><i className="fas fa-eye"></i></div>
            <h3>Crystal-Clear Visualization Before Building</h3>
            <p>Eliminate guesswork and confidently envision your future home. Our detailed plans, especially 3D renderings, provide a clear understanding of the layout, preventing costly surprises during construction.</p>
        </li>
        <li>
            <div className="benefit-icon"><i className="fas fa-chart-line"></i></div>
            <h3>Enhanced Property Value</h3>
            <p>A well-designed floor plan is a significant asset. It not only improves your living experience but also increases the appeal and long-term value of your property.</p>
        </li>
        <li>
            <div className="benefit-icon"><i className="fas fa-lightbulb"></i></div>
            <h3>Tailored to Your Unique Lifestyle</h3>
            <p>Your home should reflect you. We take the time to understand your specific needs, preferences, and lifestyle, creating a floor plan that truly caters to the way you live.</p>
        </li>
        <li>
            <div className="benefit-icon"><i className="fas fa-comments"></i></div>
            <h3>Improved Communication with Builders</h3>
            <p>Clear and detailed floor plans serve as a precise blueprint for your construction team, minimizing misunderstandings and ensuring accurate execution of your vision.</p>
        </li>
        {/* You can add more benefits as needed */}
    </ul>
</section>

                <section className="floor-plan-animation-section">
                    <h2>Visualize Your Space</h2>
                    <p>See how a floor plan comes to life with our dynamic visualization.</p>
                    <FloorPlanAnimation />
                </section>

                <section className="floor-plan-examples ">
                    <h2>Explore Sample Floor Plans</h2>
                    <p>
                        Get inspired by some examples of our diverse floor plan designs. Click on the images to view them in more detail.
                    </p>
                    <div className="floor-plan-grid">
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan1} alt="Modern Open Concept Floor Plan" />
                            <h3>Modern Open Concept</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan2} alt="Traditional Two-Story Floor Plan" />
                            <h3>Traditional Two-Story</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan3} alt="Compact Urban Living Floor Plan" />
                            <h3>Compact Urban Living</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan4} alt="Ranch Style Floor Plan" />
                            <h3>Ranch Style</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan5} alt="Luxury Multi-Generational Floor Plan" />
                            <h3>Luxury Multi-Generational</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan6} alt="Sustainable Eco-Friendly Floor Plan" />
                            <h3>Sustainable Eco-Friendly</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan7} alt="Ranch Style Floor Plan" />
                            <h3>Ranch Style</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan8} alt="Luxury Multi-Generational Floor Plan" />
                            <h3>Luxury Multi-Generational</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan6} alt="Sustainable Eco-Friendly Floor Plan" />
                            <h3>Sustainable Eco-Friendly</h3>
                        </div>
                    </div>
                </section>

                <section>
                    <h2>Ready to Bring Your Vision to Life?</h2>
                    <p>
                        Our expert team is ready to help you create the perfect floor plan for your dream home. Contact us today to discuss your project and get started.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button primary">Contact Us</button>
                    </Link>
                </section>

                <DesignProcess />
                <FAQ faqData={HouseplanfaqData} />

            </div>
        </>
    );
};

export default FloorPlan;